import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  base_url = environment.baseUrl;
  project:any;

  constructor(
    private httpclient: HttpClient,
  ) { }

  setProject(project:any){
    localStorage.setItem('project',  JSON.stringify(project));
    this.project = project;
  }

  getProject(): any{
    return JSON.parse(localStorage.getItem('project') || '[]');
  }

  getProjects(): any{
    return this.httpclient.get(this.base_url+ 'projects')
  }

  createProject(data:any): any{
    return this.httpclient.post(this.base_url+ 'projects',data)
  }

  updateProject(data:any, id): any{
    return this.httpclient.put(this.base_url+ 'projects/'+id,data)
  }


  assetsList(): any{
    this.project = this.getProject();
    return this.httpclient.get(this.base_url +'projects/'+this.project._id+ '/properties')
  }

  createAsset(data:any):any{
    this.project = this.getProject();
    return this.httpclient.post(this.base_url +'projects/'+this.project._id+ '/properties', data)
  }

  updateAsset(data:any, id):any{
   return this.httpclient.put(this.base_url+ 'properties/'+id,data)
  }

  deleteAsset(id:any):any{
    return this.httpclient.delete(this.base_url+ 'properties/'+id)
  }

  customersList(projectID:any): any{
    this.project = this.getProject();
    return this.httpclient.get(this.base_url +'customers/?projectID='+this.project._id)
  }

  emis(customerID): any{
    return this.httpclient.get(this.base_url +'emis/?customerID='+customerID)
  }

  customer(id: any): any{
    return this.httpclient.get(this.base_url +'customers/'+id)
  }

  createCustomer(propertyId:any,data:any):any{
    return this.httpclient.post(this.base_url+'properties/'+propertyId+'/customers', data)
  }

  updateCustomer(data:any, id: any):any{
   return this.httpclient.put(this.base_url+'customers/'+id,data)
  }

  deleteCustomer(id:any):any{
    return this.httpclient.delete(this.base_url+'customers/'+id)
  }

  getLeads(): any{
    return this.httpclient.get(this.base_url +'leads')
  }

  lead(id: any): any{
    return this.httpclient.get(this.base_url +'leads/'+id)
  }

  createLead(data:any):any{
    return this.httpclient.post(this.base_url+'leads', data)
  }

  updateLead(data:any, id: any):any{
   return this.httpclient.put(this.base_url+'leads/'+id,data)
  }

  deleteLead(id:any):any{
    return this.httpclient.delete(this.base_url+'leads/'+id)
  }


  allpayments(): any{
    this.project = this.getProject();
    return this.httpclient.get(this.base_url+'payments?projectID='+this.project._id)
  }
  payments(customerId:any): any{
    return this.httpclient.get(this.base_url+'payments?customerID='+ customerId)
  }
  addPayment(customerId:any,data:any){
    return this.httpclient.post(this.base_url+'customers/'+customerId+'/payments',data)
  }
  deletePaymet(id:any){
    return this.httpclient.delete(this.base_url+'payments/'+id)
  }


  getDelaers():any{
    this.project = this.getProject();
    return this.httpclient.get(this.base_url+'delears?project='+ this.project._id)
  }
  getDelaer(id:any):any{
    return this.httpclient.get(this.base_url+'delears/'+ id)
  }
  CreateDelaer(data:any):any{
    return this.httpclient.post(this.base_url+'delears', data)
  }
  UpdateDelaer(id:any, data:any):any{
    return this.httpclient.put(this.base_url+'delears/'+ id, data)
  }
  deleteDelaer(id:any):any{
    return this.httpclient.delete(this.base_url+'delears/'+ id)
  }

  getSubdelaers(delear:any):any{
    return this.httpclient.get(this.base_url+'subdelears?delear='+ delear)
  }
  getSubdelaer(id:any):any{
    return this.httpclient.get(this.base_url+'subdelears/'+ id)
  }
  CreateSubdelaer(data:any):any{
    return this.httpclient.post(this.base_url+'subdelears', data)
  }
  UpdateSubdelaer(id:any, data:any):any{
    return this.httpclient.put(this.base_url+'subdelears/'+ id, data)
  }
  deleteSubdelaer(id:any):any{
    return this.httpclient.delete(this.base_url+'subdelears/'+ id)
  }




  users():any{
    return this.httpclient.get(this.base_url+'auth/users')
  }

  getUser():any{
    return JSON.parse(localStorage.getItem('user') || '');
  }

  addUser(data:any):any{
    return this.httpclient.post(this.base_url+'auth/register',data)
  }

  editUser(id:any, data:any){
    return this.httpclient.put(this.base_url+'auth/edit/'+id, data)
  }


  deleteUser(id:any){
    return this.httpclient.delete(this.base_url+'auth/delete/'+id)
  }

  adminDash(){
    this.project = this.getProject();
    return this.httpclient.get(this.base_url+'dashboard/admin/'+this.project._id)
  }

  salesDash(){
    return this.httpclient.get(this.base_url+'dashboard/sales')
  }

  export(data, fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(data);
    // generate workbook and add the worksheet
    console.log(ws);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');
    // save to file
    XLSX.writeFile(workbook, `${fileName}.xlsx`);


  }



}
